import React from "react";
import AboutSupportImage from "../../assets/images/about-us/support.png";
import AboutTimeImage from "../../assets/images/about-us/saving-time.png";
import AboutTargetImage from "../../assets/images/about-us/helping-them.png";
import PostSalesImage from "../../assets/images/about-us/pre-sales.png";
import PowerResearchImage from "../../assets/images/about-us/power-their-research.png";

const Aim = () => {
  return (
    <>
      <section className="aim-wrapper _border-top">
        <div className="max-container">
          <div className="padd-90">
            <h2 className="roboto-bold mb40 heading29px text-center">
              Our Aim to
            </h2>

            <div className="grid-auto-fit" style={{ gridGap: "24px" }}>
              <div className="common-white-box common-shadow text-center">
                <img
                  src={AboutSupportImage}
                  height="60"
                  width="60"
                  alt="Support our Clients' Business Processes"
                  className="img-responsive"
                />
                <p className="heading20px roboto-bold mb10 mt20">
                  Streamline Hospitality Workflows
                </p>

                <p className="heading16px roboto-regular">We support hotel and travel businesses by simplifying complex sales, marketing, and guest engagement processes—saving time, reducing costs, and boosting operational efficiency.
                </p>
              </div>

              <div className="common-white-box common-shadow text-center">
                <img
                  src={AboutTimeImage}
                  height="60"
                  width="60"
                  alt="Support our Clients' Business Processes"
                  className="img-responsive"
                />

                <p className="heading20px roboto-bold mb10 mt20">
                  Enable End-to-End Sales Support
                </p>

                <p className="heading16px roboto-regular">From presales to post-stay CRM, BeyondLeadz empowers your teams across the entire customer journey—driving personalized outreach, faster conversions, and stronger guest loyalty.
                </p>

              </div>

              <div className="common-white-box common-shadow text-center">
                <img
                  src={PostSalesImage}
                  height="60"
                  width="60"
                  alt="Support our Clients' Business Processes"
                  className="img-responsive"
                />

                <p className="heading20px roboto-bold mb10 mt20">
                  Fuel Smart Decisions with Data
                </p>

                <p className="heading16px roboto-regular">Our platform enhances your research and knowledge engine with real-time data, guest behavior analytics, and actionable intelligence—so every decision is data-backed and guest-centric.
                </p>

              </div>

              <div className="common-white-box common-shadow text-center">
                <img
                  src={PowerResearchImage}
                  height="60"
                  width="60"
                  alt="Support our Clients' Business Processes"
                  className="img-responsive"
                />

                <p className="heading20px roboto-bold mb10 mt20">
                  Unlock Revenue Opportunities
                </p>

                <p className="heading16px roboto-regular">With AI-driven insights, we help you identify, target, and convert high-potential leads, turning new opportunities into long-term guests and partnerships.
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Aim;
